import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_ORDERS,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAILED,
  UPDATE_ORDER_STATUS,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_FAILED,
  GET_ORDER_WITH_ID,
  GET_ORDER_WITH_ID_SUCCESS,
  GET_ORDER_WITH_ID_FAILED,
  ACTION_RETRIEVE_RUBIKA_ORDERS,
  ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS,
  ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED,
  SCHEDULE_ORDERS,
  SCHEDULE_ORDERS_SUCCESS,
  SCHEDULE_ORDERS_FAILED,
  CANCEL_ORDER,
  CANCEL_ORDER_SUCCESS,
  CANCEL_ORDER_FAILED,
  GET_LOGS_SUCCESS,
  GET_LOGS_FAILED,
  GET_LOGS,
  GET_ALL_ORDERS_REPORT,
  GET_ALL_ORDERS_REPORT_SUCCESS,
  GET_ALL_ORDERS_REPORT_FAILED,
  UPDATE_ALL_ORDER_STATUS,
  UPDATE_ALL_ORDER_STATUS_SUCCESS,
  UPDATE_ALL_ORDER_STATUS_FAILED,
  UPDATE_ORDER_ITEM_STATUS,
  UPDATE_ORDER_ITEM_STATUS_SUCCESS,
  UPDATE_ORDER_ITEM_STATUS_FAILED,
  ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM_SUCCESS,
  ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM_FAILED,
  ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM,
  ASSIGN_ORDER_FAILED,
  ASSIGN_ORDER,
  UPDATE_ALL_ORDER_ASSIGN,
  UPDATE_ALL_ORDER_ASSIGN_SUCCESS,
  UPDATE_ALL_ORDER_ASSIGN_FAILED,
  CREATE_POST_ORDERS,
  CREATE_POST_ORDERS_SUCCESS,
  CREATE_POST_ORDERS_FAILED,
  GET_POST_ORDERS_SUCCESS,
  GET_POST_ORDERS_FAILED,
  GET_POST_ORDERS,
  GET_ORDERS_PRINT,
  GET_ORDERS_PRINT_SUCCESS,
  GET_ORDERS_PRINT_FAILED,
  CHANGE_DELIVERY_TYPE,
  CHANGE_DELIVERY_TYPE_SUCCESS,
  CHANGE_DELIVERY_TYPE_FAILED,
  ADD_ORDER_DIMENSIONS_SUCCESS,
  ADD_ORDER_DIMENSIONS_FAILED,
  ADD_ORDER_DIMENSIONS,
  DELETE_POST_ORDER,
  DELETE_POST_ORDER_SUCCESS,
  DELETE_POST_ORDER_FAILED,
  UPDATE_ORDER_DELIVERY_TYPE,
  UPDATE_ORDER_DELIVERY_TYPE_SUCCESS,
  UPDATE_ORDER_DELIVERY_TYPE_FAILED,
  GET_ORDER_ITEMS_SUCCESS,
  GET_ORDER_ITEMS_FAILED,
  GET_ORDER_ITEMS,
  CREATE_ORDER_ITEMS_SUCCESS,
  CREATE_ORDER_ITEMS,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_FAILED,
  UPDATE_ORDER,
  DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM_SUCCESS,
  DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM_FAILED,
  DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM,
  GET_PROVINCES_SUCCESS,
  GET_PROVINCES_FAILED,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAILED,
  GET_PROVINCES,
  GET_CITIES,
  GET_ALL_POST_ORDERS,
  GET_ALL_POST_ORDERS_FAILED,
  GET_ALL_POST_ORDERS_SUCCESS,
  GET_POST_ORDER_WITH_ID_SUCCESS,
  GET_POST_ORDER_WITH_ID_FAILED,
  GET_POST_ORDER_WITH_ID,
  UPDATE_POST_ORDER_STATUS_SUCCESS,
  UPDATE_POST_ORDER_STATUS_FAILED,
  UPDATE_POST_ORDER_STATUS,
  GET_LOGS_TPL_FAILED,
  GET_LOGS_TPL_SUCCESS,
  GET_TPL_LOGS,
} from './constants';

import {
  GetAllOrdersRequestBuilder,
  GetOrdersCountRequestBuilder,
  UpdateOrderStatusRequestBuilder,
  CancelOrderRequestBuilder,
  GetOrderLogsBuilder,
  UpdateAllOrderRequestBuilder,
  GetAllOrdersReportRequestBuilder,
  UpdateOrderItemStatusRequestBuilder,
  AssignOrderRequestBuilder,
  CreatePostOrderRequestBuilder,
  UpdateAllOrderAssignRequestBuilder,
  GetAllOrdersPrintRequestBuilder,
  ChangeOrderDeliveryTypeRequestBuilder,
  AddOrderDimensionsRequestBuilder,
  DeletePostOrderRequestBuilder,
  UpdateOrderDeliveryTypeRequestBuilder,
  GetAllOrderItemsRequestBuilder,
  CreateOrderItemsRequestBuilder,
  UpdateOrderRequestBuilder,
  GetPostOrdersRequestBuilder,
  GetPostOrdersCountRequestBuilder,
  UpdatePostOrderStatusRequestBuilder,
} from 'client-sdk/src/orders/orders';

import {GetAllProvincesRequestBuilder} from 'client-sdk/src/provinces/provinces';

import {GetAllCitiesRequestBuilder} from 'client-sdk/src/cities/cities';

import {
  RetrieveRubikaOrdersRequestBuilder,
  ScheduleOrdersRequestBuilder,
} from 'client-sdk/src/action-services/action-services';
import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';

import {flattenObject} from '../../utils/helpers';
import {
  AssignInventoryItemToOrderItemRequestBuilder,
  DeleteInventoryItemFromOrderItemRequestBuilder,
} from 'client-sdk/src/parcels/parcels';
import {createOrderItemsPayload} from './interfaces';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';

const token = localStorage.getItem('token') || '';

export function* getOrders(actions: any): unknown {
  try {
    const makeOrdersRequest = new GetAllOrdersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetOrdersCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeOrdersRequest);
    const count = yield client.execute(makeCountRequest);

    yield put({
      type: GET_ORDERS_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_ORDERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getProvinces(actions: any): unknown {
  try {
    const makeProvincesRequest = new GetAllProvincesRequestBuilder()
      .params(flattenObject({...actions.payload, size: 50, sort: 'name,asc'}))
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeProvincesRequest);
    yield put({
      type: GET_PROVINCES_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PROVINCES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getCities(actions: any): unknown {
  try {
    const makeCitiesRequest = new GetAllCitiesRequestBuilder()
      .params(flattenObject({...actions.payload, size: 1000, sort: 'name,asc'}))
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeCitiesRequest);
    yield put({
      type: GET_CITIES_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_CITIES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getAllOrderItems(actions: any): unknown {
  try {
    const makeOrdersRequest = new GetAllOrderItemsRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeOrdersRequest);
    yield put({
      type: GET_ORDER_ITEMS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ORDER_ITEMS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* createOrderItems(actions: any): unknown {
  const {id, body, callback} = actions.payload;
  try {
    const makeCreateOrderItemsReq = new CreateOrderItemsRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeCreateOrderItemsReq);
    yield put({
      type: CREATE_POST_ORDERS_SUCCESS,
    });
    yield put({
      type: GET_ORDER_ITEMS,
      payload: {'orderId.equals': id, size: 100},
    });
    callback && callback();
    handleNotfication('آیتم مورد نظر با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_ORDER_ITEMS_SUCCESS,
    });
    handleNotfication('اضافه کردن آیتم مورد نظر با موفقیت انجام نشد', 'error');
  }
}

export function* getOrdersPrint(actions: any): unknown {
  try {
    const makeOrdersRequest = new GetAllOrdersPrintRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeOrdersRequest);

    yield put({
      type: GET_ORDERS_PRINT_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ORDERS_PRINT_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getOrderWithId(actions: any): unknown {
  try {
    const makeOrdersRequest = new GetAllOrdersRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeOrdersRequest);
    yield put({
      type: GET_ORDER_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ORDER_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getPostOrderWithId(actions: any): unknown {
  try {
    const makeOrdersRequest = new GetPostOrdersRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeOrdersRequest);
    yield put({
      type: GET_POST_ORDER_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_POST_ORDER_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* actionRetrieveRubikaOrders(actions: any): unknown {
  try {
    const makeActionServiceRequest = new RetrieveRubikaOrdersRequestBuilder()
      .data(actions.payload)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeActionServiceRequest);
    yield put({
      type: ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS,
      data: response.data,
    });
    response.data.length === 0
      ? handleNotfication('سفارش جدیدی اضافه نشده است', 'warn')
      : handleNotfication('سفارش جدیدی اضافه شد', 'success');
    yield put({
      type: GET_ORDERS,
      payload: {page: 0, size: 10, sort: 'created,desc'},
    });
  } catch (error) {
    yield put({
      type: ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* scheduleOrdersSaga(actions: any): unknown {
  try {
    const makeActionServiceRequest = new ScheduleOrdersRequestBuilder()
      .params(actions.payload)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeActionServiceRequest);
    yield put({
      type: SCHEDULE_ORDERS_SUCCESS,
      data: response.data,
    });
    handleNotfication(
      'ایجاد و تخصیص اتوماتیک بسته با موفقیت انجام شد ',
      'success'
    );
  } catch (error) {
    yield put({
      type: SCHEDULE_ORDERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateOrderStatus(actions: any): unknown {
  const {id, body, pagination, callback} = actions.payload;
  try {
    const makeUpdateOrderStatusRequest = new UpdateOrderStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateOrderStatusRequest);
    yield put({
      type: UPDATE_ORDER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_ORDERS,
      payload: {...pagination, sort: 'created,desc'},
    });
    callback && callback();
    handleNotfication('تغییر وضعیت سفارش با موفقیت انجام شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_ORDER_STATUS_FAILED,
      error: error.message,
    });
    handleNotfication('تغییر وضعیت سفارش انجام نشد', 'error');
  }
}

export function* updatePostOrderStatus(actions: any): unknown {
  const {id, body, pagination, callback} = actions.payload;
  try {
    const makeUpdateOrderStatusRequest =
      new UpdatePostOrderStatusRequestBuilder().id(id).data(body).build();
    const client = new Client(token);
    yield client.execute(makeUpdateOrderStatusRequest);
    yield put({
      type: UPDATE_POST_ORDER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_ALL_POST_ORDERS,
      payload: {...pagination},
    });
    callback && callback();
    handleNotfication('تغییر وضعیت مرسوله با موفقیت انجام شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_POST_ORDER_STATUS_FAILED,
      error: error.message,
    });
    handleNotfication('تغییر وضعیت مرسوله انجام نشد', 'error');
  }
}

export function* updateOrderDeliveryType(actions: any): unknown {
  const {id, body, pagination, callback} = actions.payload;
  try {
    const makeUpdateOrderStatusRequest =
      new UpdateOrderDeliveryTypeRequestBuilder().id(id).data(body).build();
    const client = new Client(token);
    yield client.execute(makeUpdateOrderStatusRequest);
    yield put({
      type: UPDATE_ORDER_DELIVERY_TYPE_SUCCESS,
    });
    yield put({
      type: GET_ORDERS,
      payload: {...pagination, sort: 'created,desc'},
    });
    callback && callback();
    handleNotfication('تغییر وضعیت سفارش با موفقیت انجام شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_ORDER_DELIVERY_TYPE_FAILED,
      error: error.message,
    });
    handleNotfication('تغییر وضعیت سفارش انجام نشد', 'error');
  }
}

export function* addOrderDimensions(actions: any): unknown {
  const {id, body, callback} = actions.payload;
  try {
    const makeUpdateOrderStatusRequest = new AddOrderDimensionsRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateOrderStatusRequest);
    yield put({
      type: ADD_ORDER_DIMENSIONS_SUCCESS,
    });
    yield put({
      type: GET_ORDERS,
      payload: {sort: 'created,desc'},
    });
    callback && callback();
    handleNotfication('تغییر وضعیت سفارش با موفقیت انجام شد', 'success');
  } catch (error) {
    yield put({
      type: ADD_ORDER_DIMENSIONS_FAILED,
      error: error.message,
    });
    handleNotfication('تغییر وضعیت سفارش انجام نشد', 'error');
  }
}

export function* createPostOrder(actions: any): unknown {
  const {id, body, callback} = actions.payload;
  try {
    let makeUpdateOrderStatusRequest;
    if (body.send) {
      makeUpdateOrderStatusRequest = new CreatePostOrderRequestBuilder()
        .id(id)
        .send(id)
        .data(body)
        .build();
    } else {
      makeUpdateOrderStatusRequest = new CreatePostOrderRequestBuilder()
        .id(id)
        .data(body)
        .build();
    }
    const client = new Client(token);
    const response = yield client.execute(makeUpdateOrderStatusRequest);
    yield put({
      type: CREATE_POST_ORDERS_SUCCESS,
      data: response.data,
    });
    callback && callback();
    if (!body.send)
      handleNotfication('سفارش پستی شما با موفقیت ارسال شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_POST_ORDERS_FAILED,
      error: error.message,
    });
    if (!body.send) {
      handleNotfication('سفارش پستی شما ارسال نشد', 'error');
    }
  }
}

export function* getPostOrders(actions: any): unknown {
  const {id, body, callback} = actions.payload;
  try {
    const makeUpdateOrderStatusRequest = new CreatePostOrderRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeUpdateOrderStatusRequest);
    yield put({
      type: GET_POST_ORDERS_SUCCESS,
      data: response.data,
    });
    callback && callback();
    handleNotfication('سفارش های پستی شما با موفقیت ارسال شد', 'success');
  } catch (error) {
    yield put({
      type: GET_POST_ORDERS_FAILED,
      error: error.message,
    });
    handleNotfication('سفارش های پستی شما ارسال نشد', 'error');
  }
}

export function* getAllPostOrders(actions: any): unknown {
  const {callback, ...body} = actions.payload;
  try {
    const makeUpdateOrderStatusRequest = new GetPostOrdersRequestBuilder()
      .params(flattenObject({...body, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetPostOrdersCountRequestBuilder()
      .params(flattenObject({...body}))
      .build();
    const makeCountPackagedRequest = new GetPostOrdersCountRequestBuilder()
      .params(flattenObject({...body, "orderStatus.equals": "PACKAGED"}))
      .build();
    const makeCountResendRequest = new GetPostOrdersCountRequestBuilder()
      .params(flattenObject({...body, "orderStatus.equals": "REQUESTED_TO_RESEND"}))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeUpdateOrderStatusRequest);
    const count = yield client.execute(makeCountRequest);
    const packaged = yield client.execute(makeCountPackagedRequest);
    const resend = yield client.execute(makeCountResendRequest);

    yield put({
      type: GET_ALL_POST_ORDERS_SUCCESS,
      data: response.data,
      count: count.data,
      packaged: packaged.data,
      resend: resend.data 
    });
    callback && callback();
  } catch (error) {
    yield put({
      type: GET_ALL_POST_ORDERS_FAILED,
      error: error.message,
    });
    handleNotfication(error.message, 'error');
  }
}

export function* updateOrderItemStatus(actions: any): any {
  const {id, body, callback} = actions.payload;
  try {
    const makeUpdateOrderStatusRequest =
      new UpdateOrderItemStatusRequestBuilder().id(id).data(body).build();
    const client = new Client(token);
    yield client.execute(makeUpdateOrderStatusRequest);
    yield put({
      type: UPDATE_ORDER_ITEM_STATUS_SUCCESS,
    });
    handleNotfication('تغییر وضعیت آیتم سفارش با موفقیت انجام شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: UPDATE_ORDER_ITEM_STATUS_FAILED,
      error: error.message,
    });
    handleNotfication('تغییر وضعیت سفارش انجام نشد', 'error');
  }
}

export function* assignInventoryItemToOrderItem(actions: any): any {
  const {id, body, callback} = actions.payload;
  try {
    const makeUpdateOrderStatusRequest =
      new AssignInventoryItemToOrderItemRequestBuilder()
        .id(id)
        .data(body)
        .build();
    const client = new Client(token);
    yield client.execute(makeUpdateOrderStatusRequest);
    yield put({
      type: ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM_SUCCESS,
    });
    handleNotfication('تغییر وضعیت آیتم انبار با موفقیت انجام شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM_FAILED,
      error: error.message,
    });
    if (
      error.status === 400 &&
      error.message ===
        'inventory item and order item does not belong to same sku'
    ) {
      handleNotfication('آیتم انبار با آیتم سفارش مطابقت ندارد', 'error');
    } else {
      handleNotfication('تغییر وضعیت آیتم انبار انجام نشد', 'error');
    }
  }
}

export function* deleteInventoryItemFromOrderItem(actions: any): any {
  const {id, callback} = actions.payload;
  try {
    const makeUpdateOrderStatusRequest =
      new DeleteInventoryItemFromOrderItemRequestBuilder().id(id).build();
    const client = new Client(token);
    yield client.execute(makeUpdateOrderStatusRequest);
    yield put({
      type: DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM_SUCCESS,
    });
    handleNotfication('تغییر وضعیت آیتم انبار با موفقیت انجام شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM_FAILED,
      error: error.message,
    });
    handleNotfication('تغییر وضعیت آیتم انبار انجام نشد', 'error');
  }
}

export function* cancelOrder(actions: any): unknown {
  const {id, body, pagination} = actions.payload;
  try {
    const makeCancelRequest = new CancelOrderRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeCancelRequest);
    yield put({
      type: CANCEL_ORDER_SUCCESS,
    });
    yield put({
      type: GET_ORDERS,
      payload: {...pagination, sort: 'created,desc'},
    });
    handleNotfication('سفارش مورد نظر شمابا موفقیت لغو شد', 'success');
  } catch (error) {
    yield put({
      type: CANCEL_ORDER_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* deletePostOrder(actions: any): unknown {
  const {id, pagination, callback} = actions.payload;
  try {
    const makeCancelRequest = new DeletePostOrderRequestBuilder()
      .id(id)
      .build();
    const client = new Client(token);
    yield client.execute(makeCancelRequest);
    yield put({
      type: DELETE_POST_ORDER_SUCCESS,
    });
    yield put({
      type: GET_ORDERS,
      payload: {...pagination, sort: 'created,desc'},
    });
    callback && callback();
    handleNotfication('سفارش مورد نظر شما با موفقیت حذف شد', 'success');
  } catch (error) {
    yield put({
      type: DELETE_POST_ORDER_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getLogs(actions: any): unknown {
  try {
    const makeRequest = new GetOrderLogsBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    yield put({
      type: GET_LOGS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_LOGS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* getTPLLogs(actions: any): unknown {
  const payload = {...actions.payload};
  try {
    const response = yield ordersRepository.getTPLLogs({payload});
    yield put({
      type: GET_LOGS_TPL_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_LOGS_TPL_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getAllOrdersReport(actions: any): unknown {
  try {
    const makeOrdersRequest = new GetAllOrdersReportRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeOrdersRequest);
    yield put({
      type: GET_ALL_ORDERS_REPORT_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ALL_ORDERS_REPORT_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateAllOrderStatus(actions: any): unknown {
  const {ids, status, description, pagination} = actions.payload;
  try {
    const makeUpdateAllOrderStatusRequest = new UpdateAllOrderRequestBuilder()

      .data({ids, status, description})
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateAllOrderStatusRequest);
    yield put({
      type: UPDATE_ALL_ORDER_STATUS_SUCCESS,
    });

    yield put({
      type: GET_ORDERS,
      payload: {...pagination, sort: 'created,desc'},
    });
  } catch (error) {
    yield put({
      type: UPDATE_ALL_ORDER_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateAllOrderAssign(actions: any): unknown {
  const {ids, operatorId, description, pagination} = actions.payload;
  try {
    const makeUpdateAllOrderStatusRequest =
      new UpdateAllOrderAssignRequestBuilder()
        .id(operatorId)
        .data({ids})
        .build();
    const client = new Client(token);
    yield client.execute(makeUpdateAllOrderStatusRequest);
    yield put({
      type: UPDATE_ALL_ORDER_ASSIGN_SUCCESS,
    });

    yield put({
      type: GET_ORDERS,
      payload: {...pagination, sort: 'created,desc'},
    });
  } catch (error) {
    yield put({
      type: UPDATE_ALL_ORDER_ASSIGN_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* assignOrder(actions: any): unknown {
  const {id, body, callback} = actions.payload;
  try {
    const makeAssignOrderRequest = new AssignOrderRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeAssignOrderRequest);
    yield put({
      type: GET_ORDERS,
      payload: {sort: 'created,desc'},
    });
    handleNotfication('سفارش با موفقیت تخصیص یافت', 'success');
    if (callback) {
      callback();
    }
  } catch (error) {
    yield put({
      type: ASSIGN_ORDER_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateOrder(actions: any): unknown {
  const {body, callback} = actions.payload;
  try {
    const updateOrderReq = new UpdateOrderRequestBuilder().data(body).build();
    const client = new Client(token);
    yield client.execute(updateOrderReq);
    yield put({
      type: UPDATE_ORDER_SUCCESS,
      payload: {sort: 'created,desc'},
    });
    handleNotfication('سفارش با موفقیت ویرایش شد', 'success');
    callback();
  } catch (error) {
    yield put({
      type: UPDATE_ORDER_FAILED,
    });
    handleError(error.response);
    handleNotfication('ویرایش سفارش انجام نشد دوباره تلاش کنید', 'error');
  }
}

export function* changeOrderDeliveryType(actions: any): unknown {
  const {id, body, filters, callback} = actions.payload;
  try {
    const makeChangeOrderDeliveryTypeRequest =
      new ChangeOrderDeliveryTypeRequestBuilder().id(id).data(body).build();
    const client = new Client(token);
    yield client.execute(makeChangeOrderDeliveryTypeRequest);
    yield put({
      type: CHANGE_DELIVERY_TYPE_SUCCESS,
    });
    yield put({
      type: GET_ALL_POST_ORDERS,
      payload: {...flattenObject(filters)},
    });
    handleNotfication('نوع ارسال سفارش با موفقیت تغییر یافت', 'success');
    callback();
  } catch (error) {
    yield put({
      type: CHANGE_DELIVERY_TYPE_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* orderSaga() {
  yield takeLatest(GET_ORDERS, getOrders);
  yield takeLatest(GET_PROVINCES, getProvinces);
  yield takeLatest(GET_CITIES, getCities);
  yield takeLatest(GET_ORDERS_PRINT, getOrdersPrint);
  yield takeLatest(GET_ORDER_WITH_ID, getOrderWithId);
  yield takeLatest(GET_POST_ORDER_WITH_ID, getPostOrderWithId);
  yield takeLatest(UPDATE_ORDER_STATUS, updateOrderStatus);
  yield takeLatest(UPDATE_POST_ORDER_STATUS, updatePostOrderStatus);
  yield takeLatest(UPDATE_ORDER_DELIVERY_TYPE, updateOrderDeliveryType);
  yield takeLatest(ADD_ORDER_DIMENSIONS, addOrderDimensions);
  yield takeLatest(CREATE_POST_ORDERS, createPostOrder);
  yield takeLatest(GET_POST_ORDERS, getPostOrders);
  yield takeLatest(GET_ALL_POST_ORDERS, getAllPostOrders);
  yield takeLatest(UPDATE_ORDER_ITEM_STATUS, updateOrderItemStatus);
  yield takeLatest(
    ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM,
    assignInventoryItemToOrderItem
  );
  yield takeLatest(
    DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM,
    deleteInventoryItemFromOrderItem
  );
  yield takeLatest(UPDATE_ALL_ORDER_STATUS, updateAllOrderStatus);
  yield takeLatest(UPDATE_ALL_ORDER_ASSIGN, updateAllOrderAssign);
  yield takeLatest(ACTION_RETRIEVE_RUBIKA_ORDERS, actionRetrieveRubikaOrders);
  yield takeLatest(SCHEDULE_ORDERS, scheduleOrdersSaga);
  yield takeLatest(CANCEL_ORDER, cancelOrder);
  yield takeLatest(DELETE_POST_ORDER, deletePostOrder);
  yield takeLatest(GET_LOGS, getLogs);
  yield takeLatest(GET_TPL_LOGS, getTPLLogs);
  yield takeLatest(GET_ALL_ORDERS_REPORT, getAllOrdersReport);
  yield takeLatest(ASSIGN_ORDER, assignOrder);
  yield takeLatest(CHANGE_DELIVERY_TYPE, changeOrderDeliveryType);
  yield takeLatest(GET_ORDER_ITEMS, getAllOrderItems);
  yield takeLatest(CREATE_ORDER_ITEMS, createOrderItems);
  yield takeLatest(UPDATE_ORDER, updateOrder);
}
